/*
FWPI-404-Page.jsx (Updated)
- Added left-side stroke image for 404 illustration.
- Keeps dark gradient and responsive layout.
*/

import React from "react";

export default function FWPI404() {
    return (
        <main className=" bg-gradient-radial text-white flex items-center justify-center p-6 pt-24">
            <div className="container mx-auto max-w-6xl relative">
                <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                    {/* Left: stroke image */}
                    <div className="flex justify-center lg:justify-center">
                        <img
                            src="/assets/404.svg"
                            alt="FWPI stroke"
                            className="w-80 sm:w-full h-[28.5rem] opacity-80 drop-shadow-[0_0_20px_rgba(255,255,255,0.05)]"
                        />
                    </div>

                    {/* Right: message */}
                    <section className="space-y-6 font-urbanist">
                        <div className="inline-flex items-center gap-3 bg-white/5 px-4 py-2 rounded-xl shadow-sm w-max">
                            <span className="text-xs font-medium text-white/90 uppercase tracking-wider">404</span>
                            <span className="text-xs text-white/60">Page not found</span>
                        </div>

                        <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight">
                            Oops — we couldn’t find that page.
                        </h1>

                        <p className="text-lg text-white/75 max-w-xl">
                            Looks like the page you were trying to reach either moved or never existed. Let’s get you back on track — the FWPI universe awaits.
                        </p>

                        <div className="flex flex-wrap gap-3">
                            <a
                                href="/"
                                className="inline-flex items-center gap-2 bg-[#ffffff] text-[#0b0d11] font-semibold px-5 py-3 rounded-lg shadow hover:scale-[1.02] transition-transform focus:outline-none focus:ring-4 focus:ring-white/20"
                            >
                                Go to homepage
                            </a>

                            <a
                                href="/contact"
                                className="inline-flex items-center gap-2 border border-white/10 text-white/90 px-5 py-3 rounded-lg hover:bg-white/5 transition-colors focus:outline-none focus:ring-4 focus:ring-white/10"
                            >
                                Contact support
                            </a>
                        </div>

                        <div className="mt-4 text-sm text-white/60">
                            <strong className="text-white/90">Tip:</strong> If you typed the URL manually, double-check for typos or try searching from the homepage.
                        </div>
                    </section>
                </div>
            </div>
        </main>
    );
}